import { t } from "i18next";
import React from "react";
import { useDispatch } from "react-redux";

import { AuthForm } from "./AuthForm/AuthForm";


import "./AuthModal.scss";
import { useTypeSelector } from "../../../../hooks/useTypeSelector";
import { Link } from "react-router-dom";
import {
  setModalLogin,
  setModalRegister,
} from "../../../../store/reducers/modalsReducer";

interface IAuthModal {
  handleClosePopap: () => void;
}

const AuthModal = ({ handleClosePopap }: IAuthModal) => {
  const dispatch = useDispatch();
  const handleOpenRegisterForm = () => {
    dispatch(setModalLogin(false));
    dispatch(setModalRegister(true));
  };
  const language = useTypeSelector(
    (data) => data.settingsReducer.language.languageShort
  );
  const logoStore = useTypeSelector(
    (data) => data?.settingsReducer?.content?.skinStyles.filter(item => item.key === "logo")[0]?.image?.s3
  );
  return (
    <div className="entrance-popup-bc sign-in">
      <div className="e-p-content-holder-bc">
        <div className="e-p-content-bc">
          <div className="e-p-header-bc">
            <Link className="popup-t-logo-w-bc" to={`/${language}/`}>
              <img className="hdr-logo-bc" src={logoStore} alt="" />
            </Link>
            <div className="e-p-sections-bc">
              <div className="e-p-section-item-bc">
                <button
                  className="btn s-small register "
                  type="button"
                  title="Register"
                  onClick={handleOpenRegisterForm}
                >
                  <span>{t("admin.Register")}</span>
                </button>
              </div>
            </div>
          </div>
          <div className="e-p-body-bc">
            <AuthForm handleClosePopap={handleClosePopap} />
          </div>
        </div>
      </div>
    </div>
  );
};

export { AuthModal };
